import { useCallback, useRef } from "react";

const DOUBLE_TAP_THRESHOLD_MS = 400;

export function useDoubleTap(handler?: () => void): () => void {
  const lastTapTimeRef = useRef<number | undefined>(undefined);

  return useCallback(() => {
    if (!handler) {
      return;
    }

    const now = Date.now();

    if (
      lastTapTimeRef.current !== undefined &&
      now - lastTapTimeRef.current < DOUBLE_TAP_THRESHOLD_MS
    ) {
      lastTapTimeRef.current = undefined;
      handler();
      return;
    }

    lastTapTimeRef.current = now;
  }, [handler]);
}
